/**
 * Created by vagrant on 10.1.2017.
 * Modified by tt on 25.10.2020
 */
import fetch from "isomorphic-fetch";
import jwtDecode from "jwt-decode";

const configuration = (window as any).configuration;
const REFRESH_URL = configuration.refreshUrl;
const SP_CLIENT_ID = configuration.sp_clientId;

export const getToken = () => {
  return new Promise((resolve, reject) => {
    const token = sessionStorage.getItem("cfdui_id_token");

    // Remove token if it exists and it is expired
    if (token) {
      const decoded: any = jwtDecode(token);

      // If token is expired ask for a new one
      if (decoded.exp < Math.floor(Date.now() / 1000)) {
        console.log("Token expired, utilizing the refresh token");

        const refreshToken = sessionStorage.getItem("cfdui_refresh_token");
        const body = `grant_type=refresh_token&client_id=${SP_CLIENT_ID}&refresh_token=${refreshToken}`;

        fetch(`${REFRESH_URL}`, {
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
          }),
          method: "post",
          body: body,
        })
          .then((response) => {
            if (response.status === 401) {
              reject({ error: "not authorized" });
            }
            return response.json();
          })
          .then((tokens) => {
            sessionStorage.removeItem("cfdui_id_token");
            sessionStorage.setItem("cfdui_id_token", tokens.id_token);
            resolve(tokens.id_token);
          });
      } else {
        resolve(token);
      }
    } else {
      reject({ error: "no token" });
    }
  });
};
